import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { Table, Row, Button, Divider, Popconfirm, message, Spin } from 'antd';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { showErrorInNotification, formatMoney } from '../../../lib/util';


function dynamic_field(onChangeOption,fieldOptions,value){
    // console.log("received op",fieldOptions);
    switch(value){
        case 'simple_eval':
            return [{
                name: "Extractor Type",
                index: "extractor_type",
                type: 'select',
                onChange:onChangeOption,
                options: [
                    {
                        text: "Simple Eval",
                        value: "simple_eval"
                    },
                    {
                        text: "Regex",
                        value: "regex"
                    },
                ]
        
            },
           
            {
                name: 'Value',
                index: 'value',
                type: 'text',
            }, 
            {
                name: 'Output Field',
                index: 'output_field',
                type: 'text',
            }];
        case 'regex':
            return [
                {
                    name: "Extractor Type",
                    index: "extractor_type",
                    type: 'select',
                    onChange:onChangeOption,
                    options: [
                        {
                            text: "Simple Eval",
                            value: "simple_eval"
                        },
                        {
                            text: "Regex",
                            value: "regex"
                        },
                    ]
            
                },
                {
                    name: 'Our Column',
                    index: 'field',
                    filterable: true,
                    type: 'select',
                    options: fieldOptions
                },
                {
                    name: 'Value',
                    index: 'value',
                    type: 'text',
                }, 
                {
                    name: 'Output Field',
                    index: 'output_field',
                    type: 'text',
                },     
            ]
        default:
            return [
                {
                name: "Extractor Type",
                index: "extractor_type",
                type: 'select',
                onChange:onChangeOption,
                options: [
                    {
                        text: "Simple Eval",
                        value: "simple_eval"
                    },
                    {
                        text: "Regex",
                        value: "regex"
                    },
                ]
        
            },
            {
                name: 'Expression',
                index: 'expression',
                type: 'text',
            }, 
            {
                name: 'Output Field',
                index: 'output_field',
                type: 'text',
            }]
    }

}

const extractors_fields=[
    {
        name: 'Field Name',
        index: 'field',
        filterable: true,
        type: 'select',
        options: []
    },
    {
        name: 'Expression',
        index: 'expression',
        type: 'text',
    }, 
    {
        name: 'Output Field',
        index: 'output_field',
        type: 'text',
    }, 
    {
        name: "Type",
        index: "type",
        type: 'select',
        options: [
            {
                text: "String",
                value: "string"
            },
            {
                text: "Integer",
                value: "integer"
            },
            {
                text: "Decimal",
                value: "decimal"
            },
        ]

    },
]

const extractors_cols = ({ onEditPressed, onDeletePressed }) => [
    // {
    //     title: 'Field Name',
    //     dataIndex: 'field'
    // },
    // {
    //     title: 'Extractor Type',
    //     dataIndex: 'extractor_type',
    // },
    {
        title: 'Expression',
        dataIndex: 'expression',
        className:'word-break'
    },
    {
        title: 'Output Field',
        dataIndex: 'output_field'
    },
    {
        title: 'Type',
        dataIndex: 'type'
    },
    {
        title: "Action",
        dataIndex: "id",
        render: (id, data) => {
            return <span>
                <Button type='link' style={{ padding: 0 }} onClick={() => {
                    typeof onEditPressed === 'function' && onEditPressed(data)
                }}>Edit</Button>
                <Divider type="vertical" />
                <Popconfirm title="Are you sure you want to delete?" onConfirm={() => {
                    typeof onDeletePressed === 'function' && onDeletePressed(data.id)
                }}>
                    <Button type='link' style={{ color: 'red', padding: 0 }}>Delete</Button></Popconfirm>
            </span>
        }
    }

]

class PipelineClassifierExtractors extends Component {
    constructor(props) {
        super(props)
        this.state = {
            classifier_id: this.props.classifier_id,
            pipeline_id: this.props.pipeline_id,
            pipeline_data: this.props.pipeline_data,
            form_data: {},
            fieldOptions:[],
            edit_id: null,
            modal_open: false,
            schema: extractors_fields // dynamic_field(this.onTypeChange,[],null)
        };

        this.list_extractors = RESTExecutor.list().config({
            label: 'classifier_extractors',
        }).forId(this.props.classifier_id).connect(props.domains.datatype);


        this.post_extractors = RESTExecutor.post().config({
            label: 'classifier_extractors'
        }).callbacks((success) => {
            this.setState({
                modal_open: false,
                form_data: {
                },
                edit_id: null,

            });
            this.list_extractors.execute();

        }).connect(props.domains.datatype);

        this.patch_extractors = RESTExecutor.patch().config({
            label: 'classifier_extractors_detail',
            params:{
                classifier_id:"",
                extractor_id:""
            }
        }).callbacks((success) => {
            this.setState({
                modal_open: false,
                edit_id: null,
                form_data: {},

            });
            this.list_extractors.execute();

        }).connect(props.domains.datatype);




        if (this.props.classifier_id) {
            this.list_extractors.execute()
        };

        this.onTypeChange=this.onTypeChange.bind(this);
        this.fieldOptionAssigner=this.fieldOptionAssigner.bind(this);
    }


    onTypeChange=(key,value,d_key)=>{

        // console.log("fiel",this.state.fieldOptions)
        this.setState({
            schema: dynamic_field(this.onTypeChange,this.state.fieldOptions,value)
        })
        // this.setState({dynamic_schema:this.state.dynamic_schema({fieldOptions:this.state.fieldOptions})},()=>{
        //     this.setState({schema:this.state.dynamic_schema({onChangeOption:this.onTypeChange,fieldOptions:this.state.fieldOptions})[value]||extractors_fields({onChangeOption:this.onTypeChange})})
        // })
    }


    deleteExtractors = (id) => {

        RESTExecutor.delete().config({
            label: 'classifier_extractors_detail',
            params:{
                classifier_id:this.props.classifier_id,
                extractor_id:id
            }
        }).callbacks((success) => {
            this.list_extractors.execute();
        }, (error) => {
            showErrorInNotification(error)
            // message.error("Failed to delete Service rule extractor. Please try again.")
        }).connect(this.props.domains.datatype).execute()
    }

    handlePostPatch = (data) => {

        if (this.state.edit_id) {
            // patch
            this.patch_extractors.config({
                params:{
                    classifier_id:this.props.classifier_id,
                    extractor_id:this.state.edit_id
                }
            }).execute(data);
        } else {
            this.post_extractors.forId(this.props.classifier_id).execute(data);
        }

    }

    render() {

        if (!this.props.classifier_id) {
            return <Spin />
        }

        let list_extractors_resp = this.list_extractors.response();
        let list_extractors_data = list_extractors_resp.result || {};
        let post_extractors_resp = this.post_extractors.response();
        let patch_extractors_resp = this.patch_extractors.response();

        // console.log(list_extractors_data)
        let rowsData = list_extractors_data.rows || [];
        let rowsMeta = list_extractors_resp.meta || {};


        return (
            <div>

                <PopUpForm
                    title="Extractor"
                    width="50%"
                    forCreate={this.state.edit_id
                        ? false
                        : true}
                    initialData={this.state.form_data}
                    fields={this.state.schema}
                    open={this.state.modal_open}
                    networkState={this.state.edit_id ? patch_extractors_resp : post_extractors_resp}
                    onClose={() => this.setState({ modal_open: false })}
                    onSubmit={(data) => {
                        // console.log("DATA", data);
                        this.handlePostPatch(data)
                        // this.post_rules.execute(data);
                    }}
                />

                <Table
                scroll={{x:true}}
                    className='main-table '
                    loading={list_extractors_resp.fetching}
                    size='small'

                    pagination={{
                        simple: false,
                    position:'bottom',
                        onChange: (current, size) => {
                            this.list_extractors.config({
                                params: {
                                    per_page: size,
                                    page: current,
                                    service_rule_id: this.props.classifier_id
                                }
                            }).execute();
                        },
                        defaultCurrent: 1,
                        current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                        // defaultPageSize: 20,
                        pageSize: (rowsMeta && rowsMeta.requested_count),

                        total: (rowsMeta && rowsMeta.total_count),
                        showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    }}
                    // bordered={false}
                    title={() => <Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title style={{
                        margin: 0
                    }}
                        level={4}
                    >Classifier</Title>
                        <Button type='primary' onClick={() => {
                            this.setState({
                                edit_id: null,
                                form_data: {},
                                modal_open: true,
                                // schema:dynamic_field(this.onTypeChange,[],null)
                            })
                        }}>
                            Add New
            </Button>
                    </Row>}
                    rowKey={(record) => record.id}
                    columns={extractors_cols({
                        onEditPressed: (data) => {
                            this.setState({
                                edit_id: data.id,
                                form_data: data,
                                modal_open: true,
                                // schema:dynamic_field(this.onTypeChange,this.state.fieldOptions,data.extractor_type)
                            })
                        },

                        onDeletePressed: this.deleteExtractors,
                    })}
                    dataSource={rowsData}

                />
            </div>
        );
    }

    componentDidMount(){
        this.fieldOptionAssigner(this.props.pipeline_data)
    }
    componentDidUpdate = (prevProps) => {
        if (this.props.pipeline_id !== prevProps.pipeline_id ||
            this.props.classifier_id !== prevProps.classifier_id ||
            this.props.pipeline_data !== prevProps.pipeline_data
        ) {
            // console.log("props change",this.props)
            // console.log("name",name)
            this.setState({
                classifier_id: this.props.classifier_id,
                pipeline_id: this.props.pipeline_id,
                pipeline_data: this.props.pipeline_data,
                form_data: {
                    service_rule_id: this.props.classifier_id
                },
            });
            this.list_extractors.config({
                params: {
                    service_rule_id: this.props.classifier_id
                }
            }).execute();
            this.fieldOptionAssigner(this.props.pipeline_data)
            // fetch the new product based and set it to the state of the component
        };
    }



    fieldOptionAssigner = (data = {}) => {
        // field name option assigner
        let configs = (data.parse_config && data.parse_config.config) || [];
        let extra_configs = (data.parse_config && data.parse_config.extra_fields) || [];

        let config_array = configs.concat(extra_configs);

        let schema = this.state.schema;
        var col_options = []

        config_array.map((configObj) => {
            // Object.keys(configObj).map((key) => {
                let config_item = configObj;
                // console.log("config item", config_item)

                if (config_item.validation.type === 'string') {
                    col_options.push({
                        text: config_item.name,
                        value: config_item.name
                    });
                }
            // })

        });
        
        // console.log("field options 11",col_options)
        schema.map((item) => {
            if (item.index === 'field') {
                item['options'] = col_options
            }
        });

        this.setState({
            schema: schema
        })
       
    }


}

export default withDomains(PipelineClassifierExtractors,"datatype");
